import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";
import { getFilterCount } from "../../mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import SelectMaterialElasticSearch from '../onBoardingMaterialIdSetup/SelectMaterialElasticSearch';
import { useState, useEffect } from 'react'
import { updateRequest } from "views/pages/manage/edpOps/constant/common";
import { labelStyles } from '../sapPurchaseOrder/constants';
import { initialFilter, hardcodeDropdown, grnModule } from './constant';
import AYearPicker from '../../../../common/form-fields-mui/AYearPicker';
import { regex } from "views/pages/manage/common/constant/regex/index";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const FilterForm = ({
  closePopup,
  dropdownData,
  globalFilter,
  setGlobalFilter,
  filterCount,
  setFilterCount,
  applyFilterHandler,
  // filterFormHandler,
  searchInputHandler,
  searchHandler,
  grnType,
  userData,
  processType = 'grn',
  crossHandler,
}) => {
  const [filterForm, setFilterForm] = useState({});
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };



  useEffect(
    () => {
      setFilterForm({
        ...globalFilter,
      })
    },
    []
  );

  const create = grnType?.value === '101' || grnType === 'createSE';
  const listAndreversal = grnType?.value === '102' || grnType === 'listSE';
  const pending = grnType?.value === 'pendingScreen' || grnType === 'pendingSE';
  const ariba = grnType === 'ariba';


  const handleApplyFilter = async () => {
    if (!grnType) return failureToast("Please Select Type");
    let selectedPlants = [];

    if (filterForm?.plant) {
      selectedPlants = Array.isArray(filterForm.plant) ? filterForm.plant : [filterForm.plant];
    } else {
      selectedPlants = dropdownData?.map(p => p?.value) || [];
    }

    const normalizedFilterForm = { ...filterForm, plant: selectedPlants };

    // Count filters (PO Number and Doc No)
    const filterCounter = getFilterCount(normalizedFilterForm, ['poNumber', 'docNo']);
    setFilterCount(filterCounter);

    // Prepare payload for API
    const payload = {
      ...updateRequest(normalizedFilterForm),
      ...(normalizedFilterForm?.dateHigh ? { dateHigh: moment(normalizedFilterForm?.dateHigh).format('YYYYMMDD') } : {}),
      ...(normalizedFilterForm?.dateLow ? { dateLow: moment(normalizedFilterForm?.dateLow).format('YYYYMMDD') } : {}),
      processType: processType,
      ...((pending || ariba) ? { user: userData?.employeeId } : {}),
      ...(grnType === 'ariba' ? { longText: 'ARIBA' } : {}),
    };

    await searchHandler(payload);

    setGlobalFilter((prev) => ({
      ...prev,
      ...initialFilter,
      ...normalizedFilterForm,
    }));

    closePopup();
  };


  const removeFilterHandler = () => {
    // searchHandler({ ...initialFilter });
    // setFilterCount(0);
    crossHandler();
    setFilterCount(0);
    closePopup();
  };

  const isDisableFilter = () => {
    const hasPlant = Array.isArray(filterForm?.plant)
      ? filterForm.plant.length > 0
      : !!filterForm?.plant;

    const hasValidDateRange =
      filterForm?.dateLow &&
      filterForm?.dateHigh &&
      moment(filterForm.dateHigh).isSameOrAfter(filterForm.dateLow);

    const hasPoNumber = !!filterForm?.poNumber;

    return !((hasPlant && hasValidDateRange) || hasPoNumber);
  };


  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filters</div>
        </div>

        <div className="d-flex flex-column gap-md">

          {/* {(grnType?.value === '101' || grnType?.value === '102' || grnType?.value === 'pendingScreen') && ( */}
          <>
            <AAutoComplete
              label="Plant*"
              currentValue={filterForm?.plant}
              items={dropdownData}
              handleChange={(value) => {
                filterFormHandler("plant", value);
              }}
              selectAllMenuButton={true}
              isShowCount={true}
              isMulti={false}
              isClearable={true}

            />
            {(create || listAndreversal) && (
              <>
                <div style={labelStyles}>Material</div>
                <SelectMaterialElasticSearch
                  currentValue={filterForm?.materialNo}
                  handleChange={(value) => {
                    filterFormHandler("materialNo", value);
                  }}
                  isMulti={false}
                  // plantId={filterForm?.plant?.value}
                  // isDisabled={!filterForm?.plant}
                  dropdownMappingParams={[
                    "materialIdAndDescription",
                    "materialId",
                    "materialDescription",
                  ]}
                />
              </>
            )}
          </>
          {/* )} */}

          {listAndreversal && (
            <>
              <div style={labelStyles}>Purchase Order Date</div>
              <AYearPicker
                value={filterForm?.year ? moment(filterForm?.year, 'YYYY') : null}
                handler={(index, val, key) => {
                  filterFormHandler("year", val);
                }}
              /></>
          )}

          {pending && (
            <>
              <div style={labelStyles}>Unique ID</div>
              <AInput
                type="text"
                value={filterForm?.uuid}
                handler={(value) => {
                  filterFormHandler("uuid", value);
                }}
                placeholder="Enter"
                regex={regex?.alphaNumeric}
              />
            </>
          )}

          {(ariba || processType == 'grn' || pending || listAndreversal) && (
            <>
              <div style={labelStyles}>PO Number </div>
              <AInput
                type="text"
                value={filterForm?.poNumber}
                handler={(value) => {
                  filterFormHandler("poNumber", value);
                }}
                placeholder="Enter"
                regex={regex?.alphaNumeric}
              />
            </>
          )}

          {/* <AAutoComplete
            label="Doc Type"
            currentValue={filterForm?.docType}
            handleChange={(value) => {
              filterFormHandler("docType", value);
            }}
            items={hardcodeDropdown?.docType}
            isMulti={false}
            placeholder={"DOC TYPE*"}
            height="34px"
            isClearable={true}
          /> */}

          <div style={labelStyles}>Vendor</div>
          <SelectMaterialElasticSearch
            currentValue={filterForm?.vendor}
            handleChange={(value) => {
              filterFormHandler("vendor", value);
            }}
            isMulti={false}
            dropdownMappingParams={[
              "vendorCodeAndName",
              "vendorCode",
              "name"
            ]}
            category="VendorMaster"
            isPlantIdRequired={false}
          />

          <div style={labelStyles}>Select Creation Date</div>
          <div className={"d-flex flex justify-content-between"} style={{ columnGap: '10px' }}>
            <CustomDatePickerV2
              placeHolder="From*"
              // maxDate={moment(new Date())}
              value={filterForm?.dateLow}
              width={"18px"}
              handler={(index, date, keyName) => {
                filterFormHandler("dateLow", moment(date).startOf('day'));
                filterFormHandler("dateHigh", moment(new Date()).endOf('day'));
              }}
            />
            <CustomDatePickerV2
              placeHolder="To*"
              width={"18px"}
              // maxDate={moment(new Date())}
              value={filterForm?.dateHigh}
              handler={(index, date, keyName) => {
                filterFormHandler("dateHigh", moment(date).endOf('day'));
              }}
            />
          </div>
        </div>

        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              handleApplyFilter()
              closePopup()
            }}
            disabled={isDisableFilter()}
          >
            Apply filter
          </AButton>

          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={removeFilterHandler}
            >
              Remove
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default FilterForm;